import React from "react";
import { X } from "lucide-react";

export const inp = "w-full border border-stone px-3 py-2.5 outline-none focus:border-gold text-sm";

export function PageHead({ title, desc, action }) {
  return (
    <div className="flex items-start justify-between mb-6 flex-wrap gap-3">
      <div>
        <h1 className="font-serif text-3xl text-navy">{title}</h1>
        {desc && <p className="text-charcoal/55 mt-1 text-sm max-w-2xl">{desc}</p>}
      </div>
      {action}
    </div>
  );
}

export function Modal({ title, onClose, children, wide = false }) {
  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center p-4 overflow-y-auto" data-testid="admin-modal">
      <div className="absolute inset-0 bg-navy/40" onClick={onClose} />
      <div className={`relative bg-white border border-stone w-full ${wide ? "max-w-3xl" : "max-w-lg"} my-8 p-6`}>
        <div className="flex items-center justify-between mb-5">
          <h2 className="font-serif text-2xl text-navy">{title}</h2>
          <button onClick={onClose} className="text-charcoal/50 hover:text-navy" data-testid="modal-close"><X size={22} /></button>
        </div>
        {children}
      </div>
    </div>
  );
}

export function Field({ label, children, hint }) {
  return (
    <div className="mb-3">
      <label className="block text-sm text-navy font-medium mb-1.5">{label}</label>
      {children}
      {hint && <p className="text-xs text-charcoal/45 mt-1">{hint}</p>}
    </div>
  );
}
